module.exports = __webpack_public_path__ + "img/index-xrk.962f299d.png";